<template>
  <div class="flex h-full w-full shrink-0 items-center justify-center">
    <div
      :class="[
        colorClassesForPerspective(perspective, allPerspectives),
        shapeClassesForPerspective(perspective, allPerspectives),
        hideBorder && 'border-none!',
      ]"
      class="overflow-hidden"
    >
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import {
    colorClassesForPerspective,
    shapeClassesForPerspective,
  } from '@/core/models/feedback-perspective'
  import { type Perspective } from '@/core/models/perspective'

  interface Props {
    perspective: Perspective | string
    allPerspectives: ReadonlyArray<Perspective>
    hideBorder?: boolean
  }

  defineProps<Props>()
</script>
